import { render } from "./MainHeaderRolePopup.vue?vue&type=template&id=3e242ff3"
import script from "./MainHeaderRolePopup.vue?vue&type=script&lang=js"
export * from "./MainHeaderRolePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__